var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0167 0C9.14764 0 3.84176 2.37764 0 6.23191L6.3532 15.0167C6.3532 15.0167 11.7331 12.7645 15.0167 12.7064C18.5176 12.6444 23.6801 15.0167 23.6801 15.0167L30.6109 6.54571L28.6818 5.00555C24.9902 1.8896 20.2224 0 15.0167 0Z",
    fill: "#FB0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.482 18.5155L17.3994 21.5981L20.5636 24.7623L18.4106 26.9153L15.2465 23.7511L12.1638 26.8337L10.174 24.8439L13.2566 21.7612L10.0924 18.597L12.2454 16.4441L15.4096 19.6083L18.4922 16.5256L20.482 18.5155Z",
    fill: "#FB0404"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternetIcon);
export default __webpack_public_path__ + "static/media/NoInternetIcon.509934684fb3b8ab2842354622c7036c.svg";
export { ForwardRef as ReactComponent };